import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import { Input } from "@akuna/ui";
import { Button } from "@akuna/ui";
import { Checkbox } from "@akuna/ui";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function AppointmentBelongingsCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const {
    visibleBelongings,
    newBelongingName,
    setNewBelongingName,
    handleAddBelonging,
    handleDeleteBelonging,
    handleToggleBelongingReturned,
    isGroomingAppointment,
  } = ctrl;

  if (!isGroomingAppointment) return null;

  return (
    <section className="rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <div className="mb-2.5 text-sm font-bold">{t("appointmentDetails.groomingChecklist")}</div>
      <div className="flex gap-2">
        <Input
          value={newBelongingName}
          onChange={(e) => setNewBelongingName(e.target.value)}
          placeholder={t("appointmentDetails.belongingPlaceholder")}
          className="min-w-0 flex-1 rounded-xl bg-background-app"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              void handleAddBelonging();
            }
          }}
        />
        <Button
          onClick={() => void handleAddBelonging()}
          disabled={!newBelongingName.trim()}
          className="h-[43px] shrink-0 rounded-xl"
        >
          {t("appointmentForm.add")}
        </Button>
      </div>
      {visibleBelongings.length > 0 ? (
        <ul className="mt-3 flex flex-col gap-2">
          {visibleBelongings.map((b) => (
            <li
              key={b.id}
              className="flex items-center gap-2.5 rounded-xl border border-border/30 bg-background-app px-3 py-2"
            >
              <Checkbox
                checked={b.returned}
                onCheckedChange={(checked) =>
                  void handleToggleBelongingReturned(b.id, Boolean(checked))
                }
                aria-label={t("appointmentDetails.markBelongingReturned", { name: b.name })}
              />
              <span className="min-w-0 flex-1 truncate text-sm">{b.name}</span>
              <button
                type="button"
                aria-label={t("appointmentDetails.deleteBelonging", { name: b.name })}
                onClick={() => void handleDeleteBelonging(b.id)}
                className="flex size-8 shrink-0 items-center justify-center rounded-[10px] border border-border/30 bg-card"
              >
                <Trash2 className="size-4 text-destructive" />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
